import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { NewsletterService } from "src/app/services/newsletter.service";

@Component({
  selector: "app-newsletter",
  templateUrl: "./newsletter.component.html",
  styleUrls: ["./newsletter.component.scss"],
})
export class NewsletterComponent implements OnInit {
  newsletters = [];

  constructor(
    private router: Router,
    private readonly newsletterService: NewsletterService
  ) {}

  ngOnInit() {
    this.getNewsletters();
  }

  private getNewsletters() {
    this.newsletterService.getAll().subscribe({
      next: (data) => {
        this.newsletters = data.data.newsletters;
      },
    });
  }

  onCreate(id?) {
    let url = "/administrator-panel/newsletter-create";
    if (id) {
      url = url + "/" + id;
    }
    this.router.navigateByUrl(url);
  }
}
